import React from "react";

export default function TextAreaV2(props: any) {

    return <textarea
        defaultValue={props.defaultValue}
        value={props.value}
        onChange={props.onChange}
        className={"journalTextArea"}
        readOnly={props.readOnly}
        rows={props.rows}
        style={props.style}
    />
}
